import { SubAreaContent } from "../contentManager/SubAreaContent";

export const PracticalContent = () => {
    return <div className="practical-container">
        <h2>2. Praxisraum</h2>
        <SubAreaContent isProjectSpecific={true} area="practicalRoom" />
    </div>;
};